var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "ui large form",
      attrs: { "data-vv-scope": _vm.formScope },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateFields(_vm.formScope)
        }
      }
    },
    [
      _vm._l(_vm.chunkProperty(_vm.companyFields.slice(0, 3), 3), function(
        field,
        index
      ) {
        return _c(
          "div",
          { key: "A" + index, staticClass: "three fields" },
          [
            field[0]
              ? _c("field", {
                  attrs: {
                    field: field[0],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[1]
              ? _c("field", {
                  attrs: {
                    field: field[1],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[2]
              ? _c("field", {
                  attrs: {
                    field: field[2],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.chunkProperty(_vm.companyFields.slice(3), 2), function(
        field,
        index
      ) {
        return _c(
          "div",
          { key: "B" + index, staticClass: "two fields" },
          [
            field[0]
              ? _c("field", {
                  attrs: {
                    field: field[0],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e(),
            _vm._v(" "),
            field[1]
              ? _c("field", {
                  attrs: {
                    field: field[1],
                    scope: _vm.formScope,
                    transparent: false,
                    allowEdit: true
                  },
                  on: { input: _vm.changeFieldValue }
                })
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-421c5c2d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-421c5c2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/setup/CompanySetup.vue
// module id = D0Sa
// module chunks = 1